import { Injectable } from '@angular/core';
import { ITipoPagoData } from '@core/interfaces/entidades/tipoPago.entidad';
import { ICrearTipoPagoReq } from '@core/interfaces/request-response/tipoPago.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class TipoPagoApiService extends BaseHttpService {
  cargarActivos() {
    return this.withLoader(
      this.httpClient.get<ITipoPagoData[]>(
        `${environment.apiUrl}${environment.apiPreFix}/tipo-pago/v2/ver-activos`,
      ),
    );
  }
  cargarTodos() {
    return this.withLoader(
      this.httpClient.get<ITipoPagoData[]>(
        `${environment.apiUrl}${environment.apiPreFix}/tipo-pago/v2/ver-todos`,
      ),
    );
  }
  activarDesactivar(tipoPagoId: number) {
    return this.withLoader(
      this.httpClient.patch<ITipoPagoData>(
        `${environment.apiUrl}${environment.apiPreFix}/tipo-pago/v2/activar-desactivar/${tipoPagoId}`,
        {},
      ),
    );
  }
  editar(tipoPagoId: number, data: Partial<ICrearTipoPagoReq>) {
    return this.withLoader(
      this.httpClient.patch<ITipoPagoData>(
        `${environment.apiUrl}${environment.apiPreFix}/tipo-pago/v2/editar/${tipoPagoId}`,
        data,
      ),
    );
  }
  crear(data: ICrearTipoPagoReq) {
    return this.withLoader(
      this.httpClient.post<ITipoPagoData>(
        `${environment.apiUrl}${environment.apiPreFix}/tipo-pago/v2/crear`,
        data,
      ),
    );
  }
}
